import React from 'react'

import { Select } from '@fourthwall/components'

import { useReportType } from '../../../../hooks/useReportType'
import { useAnalyticsParams } from '../../hooks/useAnalyticsParams'
import * as S from './DevicesSelect.styled'

export const DevicesSelect = () => {
  const { reportType } = useReportType()
  const {
    queryParams: {
      devices: [devicesParam, setDevicesParam],
    },
  } = useAnalyticsParams()

  if (reportType !== 'memberships-members-change' && reportType !== 'memberships-total-members') {
    return
  }

  return (
    <S.Container>
      <Select
        label="Device"
        options={[
          { label: 'All', value: 'ALL' },
          { label: 'Web', value: 'Web' },
          { label: 'Apple', value: 'Apple' },
          { label: 'Android', value: 'Android' },
        ]}
        size="medium"
        value={devicesParam || 'ALL'}
        onValueChange={(val: string) => setDevicesParam(val as typeof devicesParam)}
      />
    </S.Container>
  )
}
